module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.a8ee1202.xml";